/*=========================================================================================
  File Name: moduleStatusMobileActions.js
  Description: Status Mobile Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	getStatusMobileManagement({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/status/mobile/management")
				.then((res) => {
					//commit('SET_STATUS_MOBILE', res.data)
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getStatusMobileManagementById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/status/mobile/management/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea un estatus para movil
	updateCurrentResourceStatusActive({commit}, payload = {status_mobile_id: null, resource_id: 0}) {
		return new Promise((resolve, reject) => {
			Api.post("/status/mobile/management", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
